import { OnSiteSearchModule } from '../onsite-search-module';
import { JSX } from '@stencil/core';
import OrderStatusOnSiteSearchModuleTemplate from './order-status-onsite-search-module.template';
import { OrderStatusDefaultTextResources } from './order-status-default-text-resources';
import deepmerge from 'deepmerge';
import { SearchQueryType } from '../../search-query-type.enum';
import { TrackingResult, TrackingResultClick } from '../../tracking';

/**
 *
 */
export class OrderStatusOnSiteSearchModule extends OnSiteSearchModule {
  /**
   * key for configuration.
   */
  static CONFIGIDENTIFIER = 'OrderStatusOnSiteSearchModule';

  /**
   * @inheritDoc
   */
  static canHandle(searchQuery: string): boolean {
    return searchQuery.match(/^(\d{5,}-?)?\d{5,}$/) !== null;
  }

  /**
   * @inheritDoc
   */
  constructor(searchQuery: string, configuration: object = {}) {
    super(searchQuery, configuration);
    window.dispatchEvent(
      new CustomEvent('on:onsite-search:resultsFound', {
        detail: {
          flag: SearchQueryType.ORGANIC,
          query: OrderStatusOnSiteSearchModule.CONFIGIDENTIFIER,
        } as TrackingResult,
      }),
    );
  }

  /**
   * click handler for redirect button to order status page.
   */
  onForwardButtonClick(element: EventTarget) {
    window.dispatchEvent(
      new CustomEvent('on:onsite-search:itemSelect', {
        detail: {
          flag: SearchQueryType.ORGANIC,
          query: OrderStatusOnSiteSearchModule.CONFIGIDENTIFIER,
          item: {
            ids: {
              globalName: 'cp-service:orderstatus',
            },
            objectID: (element as HTMLElement).dataset['pageidentifier'] ?? 'unknown',
            name: (element as HTMLElement).textContent,
            type: `${OrderStatusOnSiteSearchModule.CONFIGIDENTIFIER}::forward`,
          },
          position: 1,
        } as TrackingResultClick,
      }),
    );
  }

  /**
   * @inheritDoc
   */
  getContent(context): JSX.Element {
    const searchQuery = this.searchQuery;
    const configuration = this.configuration;
    return OrderStatusOnSiteSearchModuleTemplate({
      ref: context,
      moduleController: this,
      textResources: deepmerge(OrderStatusDefaultTextResources, configuration['text-resources'] ?? {}),
      forwardLink: configuration['forwardLink'] ?? '',
      forwardPageidentifier: configuration['forwardPageidentifier'] ?? '',
      searchQuery,
    });
  }
}
